import React from 'react';
import { useLocation } from 'react-router-dom';
import BottomTabBar from './BottomTabBar';

const HIDE_TAB_PATHS = new Set(['/onboarding', '/welcome']);

export default function Shell({ children }) {
  const { pathname } = useLocation();
  const hideTabs = HIDE_TAB_PATHS.has(pathname) || pathname.startsWith('/share/');
  return (
    <div className="gt-surround min-h-dvh w-full flex justify-center">
      <div
        className="relative w-full md:my-6 md:max-w-[440px] md:min-h-[calc(100dvh-48px)] gt-phone overflow-hidden"
        data-testid="gt-phone-canvas"
      >
        <div className={`relative min-h-dvh md:min-h-[calc(100dvh-48px)] ${hideTabs ? '' : 'pb-safe'}`}>
          {children}
        </div>
        {!hideTabs && <BottomTabBar />}
      </div>
    </div>
  );
}
